export const appendToCaptionDisplayQueue = (
    queue,
    caption,
    maximum = 4
) => [...queue, caption].slice(-maximum);
